import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Home as HomeIcon, User as UserIcon } from 'lucide-react';
import CommunityCreateModal from './CommunityCreateModal';
import { useCommunityAuth } from '../../context/CommunityAuthContext';

const CommunityBottomNav = ({ active }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  useCommunityAuth(); // kept for future role checks; safe to call

  // 3-item nav: Home (left) — Create (center, orange) — Me (right).
  const navItems = [
    { key: 'home', icon: HomeIcon, label: 'Home', path: '/community' },
    { key: 'create', icon: Plus, label: 'Create', isCreate: true },
    { key: 'profile', icon: UserIcon, label: 'Me', path: '/community/profile' },
  ];

  return (
    <>
      <motion.div
        className="bottom-nav"
        style={{ justifyContent: 'space-around' }}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          const isCreate = item.isCreate;
          return (
            <motion.button
              key={item.key}
              className={`nav-item ${isActive ? 'active' : ''} ${isCreate ? 'create-btn fab-float' : ''}`}
              onClick={() => (isCreate ? setShowModal(true) : navigate(item.path))}
              data-testid={`nav-${item.key}`}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ scale: 1.1, y: -4 }}
              whileTap={{ scale: 0.95 }}
            >
              <motion.div animate={isActive ? { scale: [1, 1.1, 1] } : {}} transition={{ duration: 0.5 }}>
                <Icon size={24} strokeWidth={isCreate ? 2.5 : 1.8} color={isCreate ? '#fff' : (isActive ? '#5DBFAD' : '#6B7280')} />
              </motion.div>
              <span className="nav-label">{item.label}</span>
            </motion.button>
          );
        })}
      </motion.div>

      <AnimatePresence>
        {showModal && <CommunityCreateModal onClose={() => setShowModal(false)} />}
      </AnimatePresence>
    </>
  );
};

export default CommunityBottomNav;
